import { useEffect, useRef, useState, } from 'react'
import { useClickAway, useToggle } from 'ahooks'
import styles from './MenuItemBox.module.less'
import cls from 'classnames'
import AIcon from '@/components/A/AIcon/AIcon'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react'
import { PAGE_LINKS } from '@/router/pageConst'
import { Link } from 'react-router-dom'
import { userService, useUserInfo } from '@/services/userService'
import DefaultAvatar from '@/components/DefaultAvatar/DefaultAvatar'


interface Props {
  className?: string
  active?: boolean
  onVisibleChange: (visible: boolean) => void
}


function MenuItemBox(props: Props) {
  const { t } = useTranslation()
  const boxRef = useRef<HTMLDivElement>(null)
  const [visible, { toggle }] = useToggle()
  const userInfo = useUserInfo()
  const [hasUserInfo, setHasUserInfo] = useState<boolean>(false)

  useEffect(() => {
    const one: boolean = Boolean(userInfo)
    const two: boolean = !userInfo?.isExpert
    setHasUserInfo(one && two)
  }, [userInfo])

  useClickAway(() => {
    if (visible) {
      toggle()
    }
  }, boxRef)

  useEffect(() => {
    props.onVisibleChange(visible)
  }, [visible])

  return <>
    <div className={styles.menuItemBox} ref={boxRef}>
      <div className={cls(styles.iconBox, props.active && styles.active)} onClick={toggle} data-testid='page-header-mobile-menu-btn'>
        {
          visible
            ? <AIcon className={styles.closeIcon} type="icon-line-global_close1" />
            : <AIcon className={styles.closeIcon} type="icon-m-line-global_more" />
        }
      </div>
    </div>
    <div className={cls(styles.menuItemList, visible && styles.visible)}>
      <Link to={PAGE_LINKS.pricing} style={{ textDecoration: 'none' }}>
        <span className={styles.menuItem}>{t('pageHeader.Pricing')}</span>
      </Link>
      {!hasUserInfo ? (
        <>
          <Link
            to={PAGE_LINKS.login}
            state={{ mode: 'login' }}
            style={{ textDecoration: 'none' }}
          >
            <span className={styles.menuItem}>{t('pageHeader.signIn')}</span>
          </Link>
          <Link
            to={hasUserInfo ? PAGE_LINKS.project : PAGE_LINKS.login}
            state={hasUserInfo ? undefined : { mode: 'sign' }}
            style={{ textDecoration: 'none' }}
          >
            <span className={styles.menuItem}>{t('pageHeader.signUp')}</span>
          </Link>
        </>
      )
        : <div className={styles.userBox}>
          <div className={styles.user}>
            <DefaultAvatar className={styles.avatar} name={userInfo?.name || ''} avatar={userInfo?.avatar}></DefaultAvatar>
            <div className={styles.name}>{userInfo?.name}</div>
          </div>
          <div className={styles.logout} data-testid='page-header-mobile-logout-btn' onClick={() => {
            userService.logout()
          }}>
            <AIcon className={styles.logoutIcon} type="icon-line-global_exit" />
            <span>{t('dashboard.layout.logout')}</span>
          </div>
        </div>
      }
    </div>
  </>
}

export default observer(MenuItemBox)
